import React from "react";
import { Button, Layout, Space, Typography } from "antd";
import { MenuOutlined, MoonOutlined, SunOutlined } from "@ant-design/icons";
import type { User } from "../../../types";

const { Header } = Layout;
const { Title, Text } = Typography;

interface AdminHeaderProps {
  currentUser: User | null;
  activeLabel: string;
  profileLoading: boolean;
  isDark: boolean;
  isMobile: boolean;
  onProfile: () => void;
  onLogout: () => void;
  onToggleTheme: () => void;
  onMenuClick: () => void;
}

export const AdminHeader: React.FC<AdminHeaderProps> = ({
  currentUser,
  activeLabel,
  profileLoading,
  isDark,
  isMobile,
  onProfile,
  onLogout,
  onToggleTheme,
  onMenuClick,
}) => (
  <Header className="admin-console__header">
    <Space align="center" size="middle">
      {isMobile && (
        <Button
          type="text"
          icon={<MenuOutlined style={{ fontSize: "20px", color: isDark ? "#e2e8f0" : "#334155" }} />}
          onClick={onMenuClick}
          className="admin-console__menu-trigger"
        />
      )}
      <div className="admin-console__header-left">
        <Text className="admin-console__eyebrow">SATASHKENT SSO</Text>
        <div className="admin-console__header-title-area">
          <Title level={isMobile ? 4 : 3} style={{ margin: 0 }}>Admin Console</Title>
          {!isMobile && (
            <>
              <span className="admin-console__header-separator">/</span>
              <Text className="admin-console__header-active-label">{activeLabel}</Text>
            </>
          )}
        </div>
      </div>
    </Space>
    <Space size="large">
      {!isMobile && (
        <Text className="admin-console__header-user-name">
          {currentUser?.fullName || currentUser?.username}
        </Text>
      )}
      <Space>
        <Button
          icon={isDark ? <SunOutlined /> : <MoonOutlined />}
          onClick={onToggleTheme}
          title={isDark ? "Switch to light mode" : "Switch to dark mode"}
        />
        {!isMobile && (
          <>
            <Button onClick={onProfile} loading={profileLoading}>Profile</Button>
            <Button danger onClick={onLogout}>Logout</Button>
          </>
        )}
      </Space>
    </Space>

  </Header>
);

